// extracted by mini-css-extract-plugin
module.exports = {"atm_vy_1k8s52q":"atm_vy_1k8s52q","atm_e2_1k8s52q":"atm_e2_1k8s52q"};